export default __webpack_public_path__ + "media/color/gnt-2649fdc6.svg";